import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    staticClass: "payment-connect",
    attrs: {
      title: "".concat(_vm.form.status === "2" ? "确认退款" : "修改退款信息"),
      width: "450px",
      visible: _vm.visible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      close: _vm.cancel
    }
  }, [_c("div", [_vm.title ? _c("div", {
    staticClass: "popover-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c("div", {
    staticClass: "popover-content"
  }, [_c("el-form", {
    ref: "ruleForm",
    staticClass: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "应退金额",
      prop: "amount"
    }
  }, [_c("span", [_vm._v(" ¥ " + _vm._s(_vm.formatThousands(_vm.form.amount)))])]), _c("el-form-item", {
    attrs: {
      label: "退还方",
      prop: "payer"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payer))])]), _c("el-form-item", {
    attrs: {
      label: "打款方",
      prop: "payee"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.form.payee))]), _c("SourceTag", {
    attrs: {
      type: _vm.form.dataSource
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "退款流水",
      prop: "reimburseSerialNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入退款流水号",
      size: "small"
    },
    model: {
      value: _vm.form.reimburseSerialNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reimburseSerialNumber", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.reimburseSerialNumber"
    }
  }, [_c("el-button", {
    attrs: {
      slot: "append",
      loading: _vm.searchLoading
    },
    on: {
      click: _vm.search
    },
    slot: "append"
  }, [_vm._v("查询")])], 1), _vm.subInfo.payerName && _vm.form.reimburseSerialNumber ? _c("div", {
    staticClass: "other-info"
  }, [_c("div", [_c("span", [_vm._v("交易金额：¥ " + _vm._s(_vm.formatThousands(_vm.subInfo.amount)))])]), _c("div", [_c("span", [_vm._v("打款方：" + _vm._s(_vm.subInfo.payerName) + " "), _c("SourceTag", {
    attrs: {
      size: "mini",
      zoom: 0.7,
      type: _vm.subInfo.dataSource
    }
  })], 1)]), _c("div", [_c("span", [_vm._v("收款方：" + _vm._s(_vm.subInfo.recipientName))])])]) : _vm._e()], 1), _vm.isAli ? _c("el-form-item", {
    attrs: {
      label: "退还回单",
      prop: "slip"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.slip
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "slip", $event);
      }
    }
  })], 1) : _vm._e()], 1)], 1)]), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };